import { api } from '@/shared/api/axios';
import type { LoginCredentials, LoginResponse } from '@/shared/types/auth';
import type { CurrentUser } from '@/shared/types/index';

export const authPaths = {
  login: '/api/auth/login',
  logout: '/api/auth/logout',
  me: '/api/auth/me',
  changePassword: '/api/auth/change-password',
} as const;

/**
 * Thin wrapper over the EXISTING auth endpoints. No refresh/forgot/remember —
 * those don't exist on the backend (see docs/architecture/authentication.md).
 */
export const authService = {
  login(credentials: LoginCredentials) {
    return api.post<LoginResponse>(authPaths.login, credentials).then((r) => r.data);
  },
  logout() {
    return api.post(authPaths.logout).then((r) => r.data);
  },
  /** Session restore + permission load. 401 here = no/invalid session. */
  me() {
    return api.get<CurrentUser>(authPaths.me).then((r) => r.data);
  },
  changePassword(currentPassword: string, newPassword: string) {
    return api
      .post(authPaths.changePassword, { currentPassword, newPassword })
      .then((r) => r.data);
  },
};
